import { useEffect, useState } from 'react';

function hasBeenDismissed(storageKey: string) {
  try {
    return sessionStorage.getItem(storageKey) === 'true';
  } catch {
    return false;
  }
}

function markAsDismissed(storageKey: string) {
  try {
    sessionStorage.setItem(storageKey, 'true');
  } catch {
    // sessionStorage can be unavailable (e.g. private mode); fail silently
  }
}

/**
 * Opens a popup once per browser session. Once closed, it stays closed on
 * every page until the tab/session ends.
 */
export const useSessionPopup = (storageKey: string, delayTimer = 0) => {
  const [isModalOpen, setModalOpen] = useState<boolean>(false);

  useEffect(() => {
    if (hasBeenDismissed(storageKey)) return undefined;

    const timer = setTimeout(() => {
      setModalOpen(true);
    }, delayTimer);

    return () => clearTimeout(timer);
  }, [storageKey, delayTimer]);

  function onCloseHandler() {
    setModalOpen(false);
    markAsDismissed(storageKey);
  }

  return {
    isModalOpen,
    onCloseHandler
  };
};
